/** Currently open chat contact (Messages page). Used to suppress inbound toasts. */
let openContactId: number | null = null;

export function setOpenChatContactId(id: number | null) {
  openContactId = id != null && Number.isFinite(Number(id)) ? Number(id) : null;
}

export function getOpenChatContactId(): number | null {
  return openContactId;
}
